import { paths } from '../lib/paths'
import { ModelApiKey } from '~/types/models'

/**
 * Returns the path based on records _modelApiKey and slug
 *
 * @returns {string} path
 */
export default function (modelApiKey: string, slug: string): string | undefined {
  let path: string | undefined
  switch (modelApiKey) {
    case 'index':
      path = '/'
      break
    case 'page':
      path = `/${slug}`
      break
    case 'article':
      path = `/${paths[ModelApiKey.Article].path}/${slug}`
      break
    case 'work':
      path = `/${paths[ModelApiKey.Work].path}/${slug}`
      break
    case 'job':
      path = `/${paths[ModelApiKey.Job].path}/${slug}`
      break
    default:
      console.warn(`No path found for '${modelApiKey}' model.`)
  }

  return path
}
